import { render, staticRenderFns } from "./ValorMonetarioPersonalizado.vue?vue&type=template&id=ff3e64a0&scoped=true&"
import script from "./ValorMonetarioPersonalizado.vue?vue&type=script&lang=js&"
export * from "./ValorMonetarioPersonalizado.vue?vue&type=script&lang=js&"
import style0 from "./ValorMonetarioPersonalizado.vue?vue&type=style&index=0&id=ff3e64a0&scoped=true&lang=css&"
import style1 from "./ValorMonetarioPersonalizado.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3e64a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
